/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Grid,
  TextField,
  InputLabel,
  IconButton,
  FilledInput,
  FormControl,
  InputAdornment,
  FormHelperText,
} from "@material-ui/core";
import { store } from "../../Context/Store";
import { Redirect } from "react-router-dom";
import { LoginStyle } from "./style";
import { ValidationTypes } from "../../utils/Validation/Constant";
import { CheckLogin, LoginAuth } from "../../API/Pins";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useContext, useEffect, useState } from "react";

import OptimeLogo from "../../assets/logo.png";
import Validation from "../../utils/Validation";
import SubmitButton from "../../Components/SubmitButton";

const Login = () => {
  const [UserName, setUserName] = useState("");
  const [UserNameError, setUserNameError] = useState("");
  const [Password, setPassword] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [ShowPassword, setShowPassword] = useState(false);

  const [UserIsLogin, setUserIsLogin] = useState(false);

  const context = useContext(store);
  const { dispatch } = context;

  const styleConf = {
    error: !!UserNameError || !!PasswordError,
  }
  const classes = LoginStyle(styleConf);

  const OnEnter = (e, callBack) => {
    if (e.key === 'Enter') {
      callBack();
    };
  };

  useEffect(() => {
    const CheckAuth = async () => {
      try {
        const res = await CheckLogin();
        dispatch({ type: "SET_ROLE", role: res?.data?.role })
        setUserIsLogin(true);
      } catch (error) {
        console.dir(error)
        setUserIsLogin(false);
      };
    };

    CheckAuth();
  }, []);

  const handleSubmitLoginForm = async () => {
    // Validation
    let usernameValidate = Validation(UserName, ValidationTypes.USERNAME_TYPE);
    let passwordValidate = Validation(Password, ValidationTypes.PASSWORD_TYPE);
    setUserNameError(usernameValidate);
    setPasswordError(passwordValidate);

    if (!usernameValidate && !passwordValidate) {
      const data = {
        username: UserName,
        password: Password
      };
      try {
        await LoginAuth(data);
        setUserIsLogin(true)
      } catch (error) {
        console.dir(error)
        setUserNameError("Username or Password is incorrect!");
        setPasswordError("Username or Password is incorrect!");
      }

    };
  };

  if (UserIsLogin) {
    return <Redirect to="/" />
  }

  return (
    <Grid
      container
      className={classes.fullHeight}
    >
      <Grid item style={{ width: 500 }}>
        {/* <LinearLoading loading={!!props.LoginUserState.request}> */}
        <h1 className={classes.userTitle}> Login User</h1>

        <Box className={classes.formWrapper}>
          <Box className={classes.inputWrapper}>
            <TextField
              className={classes.TextField}
              id="userName"
              label="Username"
              value={UserName}
              onChange={(e) => setUserName(e.target.value)}
              type="text"
              error={!!UserNameError}
              helperText={UserNameError}
              variant="filled"
              name="Username"
              onKeyPress={(e) => OnEnter(e, handleSubmitLoginForm)}
            />
          </Box>

          <Box className={classes.inputWrapper}>
            <FormControl
              className={classes.TextField}
              variant="filled"
            >
              <InputLabel htmlFor="password"> Password </InputLabel>
              <FilledInput
                id="password"
                autoComplete="new-password"
                type={ShowPassword ? "text" : "password"}
                value={Password}
                name="password"
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={(e) => OnEnter(e, handleSubmitLoginForm)}
                error={!!PasswordError}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                    >
                      {ShowPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <FormHelperText className={PasswordError ? classes.errorHlperText : ''} id="password">{PasswordError}</FormHelperText>
            </FormControl>
          </Box>

          <div className={classes.submitWrapper}>
            <SubmitButton
              style={{ borderRadius: 50 }}
              onClick={handleSubmitLoginForm}
            >
              Login User
            </SubmitButton>
          </div>
        </Box>
      </Grid>

      <img
        className={classes.optimeLogo}
        src={OptimeLogo}
        alt="optime AI logo"
      />

    </Grid>
  );
};

export default Login;
